module.exports = __webpack_public_path__ + "img/51.8.TSS.5fb8072f.png";